export default __webpack_public_path__ + "static/media/location_preview_fabled_forest.ad7d8323.svg";